import { memo } from 'react';

import ChevronDown from '@eduzz/houston-icons/ChevronDown';
import ChevronUp from '@eduzz/houston-icons/ChevronUp';

import { ChevronDownButton } from './styles';

interface IProps {
  show: boolean;
  onClick: () => void;
}

const ToggleButtonIcon: React.FC<IProps> = ({ show, onClick }) => {
  return <ChevronDownButton onClick={() => onClick()}>{show ? <ChevronUp /> : <ChevronDown />}</ChevronDownButton>;
};

export default memo(ToggleButtonIcon);
